export const mangaCategories = [
  { slug: 'shonen', name: '少年热血', icon: 'ri-fire-line', description: '热血战斗与冒险成长' },
  { slug: 'shojo', name: '少女恋爱', icon: 'ri-heart-line', description: '纯爱浪漫与青春物语' },
  { slug: 'seinen', name: '青年漫画', icon: 'ri-user-star-line', description: '深度剧情与写实风格' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '轻松幽默与日常趣事' },
  { slug: 'fantasy', name: '奇幻异世', icon: 'ri-magic-line', description: '异世界冒险与奇幻设定' },
  { slug: 'horror', name: '悬疑惊悚', icon: 'ri-ghost-line', description: '紧张悬疑与推理惊悚' },
  { slug: 'sports', name: '运动竞技', icon: 'ri-basketball-line', description: '热血竞技与团队拼搏' },
  { slug: 'slice-of-life', name: '治愈温情', icon: 'ri-sun-line', description: '温暖治愈与生活感悟' },
];

export const mangaList = [
  {
    id: 1,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: 'shonen',
    categoryName: '少年热血',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20young%20warrior%20with%20a%20katana%20sword%20in%20a%20dynamic%20fighting%20pose%2C%20warm%20sakura%20petals%20falling%20around%2C%20traditional%20Japanese%20demon%20slayer%20aesthetic%20with%20dark%20and%20light%20contrast%2C%20vibrant%20red%20and%20soft%20pink%20color%20palette%2C%20anime%20art%20style%20with%20clean%20lines%20and%20dramatic%20lighting%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    rating: 9.8,
    views: 1280000,
    status: '已完结',
    chapters: 205,
    summary: '大正时代，少年灶门炭治郎一家遭鬼袭击，唯一幸存的妹妹祢豆子却变成了鬼。为了让妹妹恢复人类之身，炭治郎踏上了成为鬼杀队剑士的道路。这是一部关于亲情、勇气与不屈意志的史诗级热血漫画。',
    tags: ['热血', '战斗', '奇幻', '感人'],
    updateDate: '2024-05-18',
  },
  {
    id: 2,
    title: '咒术回战',
    author: '芥见下下',
    category: 'shonen',
    categoryName: '少年热血',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20modern%20sorcerer%20with%20dark%20hair%20and%20supernatural%20energy%20surrounding%20him%2C%20dynamic%20action%20pose%20with%20glowing%20cursed%20energy%20effects%2C%20urban%20fantasy%20aesthetic%20with%20Tokyo%20cityscape%20background%2C%20vibrant%20contrast%20colors%2C%20clean%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    rating: 9.6,
    views: 1150000,
    status: '连载中',
    chapters: 268,
    summary: '高中生虎杖悠仁吞下了诅咒之王两面宿傩的手指，从此踏入了咒术师的世界。在东京都立咒术高等专门学校，他与伙伴们一起对抗诅咒，守护人类的和平。',
    tags: ['热血', '战斗', '超自然', '黑暗奇幻'],
    updateDate: '2024-06-01',
  },
  {
    id: 3,
    title: '间谍过家家',
    author: '远藤达哉',
    category: 'comedy',
    categoryName: '搞笑日常',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20family%20of%20three%20with%20the%20father%20in%20a%20suit%20the%20mother%20with%20red%20hair%20and%20a%20cute%20little%20girl%20with%20pink%20hair%2C%20warm%20and%20humorous%20slice%20of%20life%20atmosphere%2C%20spy%20theme%20elements%20subtly%20blended%20in%2C%20soft%20pastel%20color%20palette%2C%20clean%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    rating: 9.5,
    views: 980000,
    status: '连载中',
    chapters: 98,
    summary: '为了执行秘密任务，顶级间谍"黄昏"需要组建一个临时家庭。他收养了能读心的超能力少女阿尼亚，并与隐藏身份的杀手约尔假结婚。这个看似普通的家庭，其实每个人都藏着不为人知的秘密。',
    tags: ['搞笑', '温馨', '间谍', '家庭'],
    updateDate: '2024-05-28',
  },
  {
    id: 4,
    title: '葬送的芙莉莲',
    author: '山田钟人',
    category: 'fantasy',
    categoryName: '奇幻异世',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20an%20elf%20girl%20with%20long%20silver%20hair%20and%20a%20staff%20walking%20through%20a%20beautiful%20fantasy%20landscape%2C%20melancholic%20yet%20warm%20atmosphere%2C%20golden%20sunset%20lighting%2C%20adventure%20fantasy%20theme%20with%20gentle%20emotional%20tone%2C%20soft%20color%20palette%20with%20warm%20accents%2C%20clean%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    rating: 9.7,
    views: 890000,
    status: '连载中',
    chapters: 132,
    summary: '打倒魔王后，勇者队伍中的精灵魔法使芙莉莲踏上了了解人类的旅程。作为长寿的精灵，她在旅途中逐渐理解了与人类伙伴短暂相处的珍贵意义，是一部充满温情与哲思的奇幻佳作。',
    tags: ['奇幻', '治愈', '冒险', '感人'],
    updateDate: '2024-05-30',
  },
  {
    id: 5,
    title: '辉夜大小姐想让我告白',
    author: '赤坂明',
    category: 'comedy',
    categoryName: '搞笑日常',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20handsome%20student%20council%20president%20and%20a%20beautiful%20vice%20president%20facing%20each%20other%20with%20romantic%20tension%2C%20school%20romance%20comedy%20theme%2C%20elegant%20academy%20setting%2C%20soft%20pink%20and%20warm%20tones%2C%20clean%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    rating: 9.4,
    views: 1050000,
    status: '已完结',
    chapters: 281,
    summary: '在名门秀知院学园，学生会会长白银御行和副会长四宫辉夜互相暗恋，却都因为自尊心过高而不愿先表白。两人展开了一场"如何让对方先告白"的恋爱头脑战，笑料百出又甜蜜动人。',
    tags: ['恋爱', '搞笑', '校园', '日常'],
    updateDate: '2024-04-15',
  },
  {
    id: 6,
    title: '链锯人',
    author: '藤本树',
    category: 'shonen',
    categoryName: '少年热血',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20young%20man%20with%20chainsaw%20arms%20and%20a%20devilish%20grin%2C%20dark%20urban%20fantasy%20setting%2C%20chaotic%20and%20energetic%20atmosphere%2C%20high%20contrast%20red%20and%20black%20color%20scheme%2C%20gritty%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    rating: 9.3,
    views: 920000,
    status: '连载中',
    chapters: 178,
    summary: '穷困潦倒的少年淀治为了还债成为了恶魔猎人，在濒死之际与链锯恶魔波奇塔融合，获得了变身链锯人的能力。被公安对魔特异课收编后，他开始了与恶魔战斗的全新人生。',
    tags: ['热血', '黑暗奇幻', '战斗', '猎奇'],
    updateDate: '2024-05-25',
  },
  {
    id: 7,
    title: '蓝色监狱',
    author: '金城宗幸',
    category: 'sports',
    categoryName: '运动竞技',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20soccer%20player%20in%20dynamic%20kicking%20pose%20on%20a%20futuristic%20blue%20soccer%20field%2C%20intense%20sports%20competition%20theme%2C%20cool%20blue%20and%20white%20color%20palette%2C%20energetic%20and%20competitive%20atmosphere%2C%20clean%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    rating: 9.2,
    views: 780000,
    status: '连载中',
    chapters: 262,
    summary: '日本足球协会为了培养世界第一的前锋，启动了"蓝色监狱"计划。300名高中前锋被关进封闭设施，通过残酷的淘汰赛制，争夺唯一的日本代表前锋宝座。',
    tags: ['运动', '竞技', '热血', '心理战'],
    updateDate: '2024-05-22',
  },
  {
    id: 8,
    title: '夏目友人帐',
    author: '绿川幸',
    category: 'slice-of-life',
    categoryName: '治愈温情',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20gentle%20young%20man%20with%20a%20fat%20cat%20yokai%20companion%20in%20a%20peaceful%20Japanese%20countryside%20setting%2C%20cherry%20blossom%20trees%20and%20soft%20sunlight%2C%20heartwarming%20supernatural%20slice%20of%20life%20atmosphere%2C%20warm%20pastel%20color%20palette%2C%20clean%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    rating: 9.6,
    views: 860000,
    status: '连载中',
    chapters: 120,
    summary: '高中生夏目贵志继承了祖母的"友人帐"——一本记录着众多妖怪名字的契约书。他与妖怪猫咪老师一起，将名字归还给各路妖怪，在这个过程中遇见了许多温暖而感人的故事。',
    tags: ['治愈', '妖怪', '温情', '日常'],
    updateDate: '2024-05-20',
  },
  {
    id: 9,
    title: '我推的孩子',
    author: '赤坂明',
    category: 'seinen',
    categoryName: '青年漫画',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20beautiful%20idol%20girl%20with%20star%20eyes%20on%20stage%20under%20spotlight%2C%20entertainment%20industry%20theme%20with%20glamorous%20yet%20dark%20undertones%2C%20contrasting%20bright%20stage%20lights%20and%20shadows%2C%20vibrant%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    rating: 9.4,
    views: 950000,
    status: '连载中',
    chapters: 152,
    summary: '妇产科医生吾郎是天才偶像星野爱的狂热粉丝，却意外转生成为了爱的孩子。在演艺圈的璀璨与阴暗交织中，他（她）与双胞胎妹妹一起踏上了追寻母亲足迹的道路。',
    tags: ['演艺圈', '转生', '悬疑', '偶像'],
    updateDate: '2024-05-31',
  },
  {
    id: 10,
    title: '迷宫饭',
    author: '九井谅子',
    category: 'fantasy',
    categoryName: '奇幻异世',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20group%20of%20fantasy%20adventurers%20cooking%20monster%20ingredients%20in%20a%20dungeon%2C%20delicious%20monster%20cuisine%20theme%2C%20warm%20and%20humorous%20cooking%20scene%2C%20fantasy%20dungeon%20background%2C%20rich%20warm%20color%20palette%2C%20clean%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    rating: 9.3,
    views: 720000,
    status: '已完结',
    chapters: 97,
    summary: '在迷宫深处，冒险者莱欧斯的小队在遭遇炎龙后损失惨重。为了节省资金救回被吞食的妹妹，他决定就地取材——在迷宫中狩猎魔物，将它们烹饪成美味的料理！',
    tags: ['奇幻', '美食', '冒险', '搞笑'],
    updateDate: '2024-03-20',
  },
  {
    id: 11,
    title: '排球少年!!',
    author: '古馆春一',
    category: 'sports',
    categoryName: '运动竞技',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20volleyball%20players%20jumping%20high%20to%20spike%20the%20ball%20in%20an%20intense%20match%2C%20high%20school%20sports%20theme%2C%20dynamic%20action%20and%20teamwork%2C%20bright%20orange%20and%20black%20uniform%20colors%2C%20energetic%20atmosphere%2C%20clean%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    rating: 9.7,
    views: 1100000,
    status: '已完结',
    chapters: 402,
    summary: '身材矮小的日向翔阳被"小巨人"的身影所震撼，立志成为排球选手。进入乌野高中后，他与天才二传手影山飞雄组成了最强的"怪人快攻"组合，向着全国大赛的目标奋勇前进。',
    tags: ['运动', '热血', '青春', '团队'],
    updateDate: '2024-02-10',
  },
  {
    id: 12,
    title: '致不灭的你',
    author: '大今良时',
    category: 'seinen',
    categoryName: '青年漫画',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20of%20a%20mysterious%20white%20haired%20immortal%20being%20in%20a%20vast%20snowy%20landscape%2C%20philosophical%20and%20poetic%20atmosphere%2C%20lonely%20yet%20beautiful%20journey%20through%20time%2C%20soft%20cool%20white%20and%20warm%20subtle%20tones%2C%20clean%20anime%20art%20style%2C%20pure%20white%20background&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    rating: 9.5,
    views: 680000,
    status: '连载中',
    chapters: 186,
    summary: '一个神秘的白色球体被投放到地球上，它能够变化成受到刺激的物体的形态。从石头到苔藓，从狼到人类——名为"不死"的存在，在漫长的旅途中逐渐理解生命与情感的意义。',
    tags: ['哲学', '奇幻', '感人', '冒险'],
    updateDate: '2024-05-15',
  },
];

export const faqList = [
  {
    question: '樱花动漫之家是什么类型的网站？',
    answer: '樱花动漫之家是一个专注于日本漫画（日漫）的资讯与资源聚合平台。我们为日漫爱好者提供热门漫画推荐、排行榜单、新番资讯以及详细的漫画介绍，帮助大家发现更多好看且高质量的日漫作品。',
  },
  {
    question: '网站上的漫画可以免费阅读吗？',
    answer: '樱花动漫之家主要提供漫画的资讯、推荐和介绍信息。我们聚合各大正版漫画平台的资源入口，引导用户前往官方或授权平台进行正版阅读，支持漫画作者的创作。部分内容可能包含免费阅读指引。',
  },
  {
    question: '如何找到适合自己的漫画推荐？',
    answer: '你可以通过首页的"热门推荐"和"排行榜单"快速发现人气漫画，也可以通过分类标签（少年热血、少女恋爱、奇幻异世等）浏览特定类型的作品。每部漫画都有详细的介绍和标签，帮助你快速判断是否适合自己的口味。',
  },
  {
    question: '网站上的漫画资讯更新频率如何？',
    answer: '我们的编辑团队每日更新漫画资讯，追踪最新连载动态。热门漫画的更新信息会在第一时间同步，确保你不会错过任何精彩内容。连载中的漫画会标注最新的更新日期和章节进度。',
  },
  {
    question: '怎样在网站上搜索特定的漫画？',
    answer: '你可以在首页使用搜索功能输入漫画名称或作者名进行查找。此外，也可以通过分类浏览和标签筛选来发现更多感兴趣的漫画作品。如果你找不到想看的漫画，欢迎通过联系表单向我们反馈。',
  },
  {
    question: '樱花动漫之家有手机App吗？',
    answer: '目前樱花动漫之家为响应式网站设计，完美适配手机、平板和桌面端浏览器。你可以直接在移动设备上访问我们的网站，获得与App同样流畅的浏览体验。未来我们会考虑推出专属App。',
  },
];

export const testimonials = [
  {
    name: '小明',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20young%20man%20portrait%20avatar%2C%20friendly%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    comment: '自从发现了樱花动漫之家，我的追漫生活变得超级方便！推荐算法也很准，每次都能找到我喜欢的热血漫画。',
    rating: 5,
  },
  {
    name: '樱花飘落',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20young%20woman%20portrait%20avatar%2C%20gentle%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    comment: '分类做得太好了！我是少女漫爱好者，在这里找到了好多冷门但超级好看的漫画，每一部都值得反复品味。',
    rating: 5,
  },
  {
    name: '漫无止境',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20teenage%20boy%20portrait%20avatar%2C%20energetic%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    comment: '更新速度真的快！每次漫画更新第一时间就能看到资讯，再也不用到处搜了。排行也很靠谱，跟着推荐看准没错。',
    rating: 5,
  },
];